module.exports = __webpack_public_path__ + "static/media/Breast Surgery-Family Cancer History-2@3x.f10038b9.png";